import React from "react";
import Hero from "../components/Hero";
import ScrollSection from "../components/ScrollSection";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      <main className="flex-1 w-full">
        <Hero />
        <ScrollSection />
      </main>

      <footer className="bg-black text-white w-full">
        <Footer />
      </footer>
    </div>
  );
};

export default Home;


// import React from "react";
// import Hero from "../components/Hero";
// import ScrollSection from "../components/ScrollSection";
// import Footer from "../components/Footer";

// const Home = () => {
//   return (
//     <div className="relative min-h-screen w-full bg-black text-white">
//       {/* Main Content */}
//       <main className="flex flex-col w-full">
//         <div className="w-full">
//           <Hero />
//         </div>
        
//         <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 max-w-[2000px] mx-auto">
//           <ScrollSection />
//         </div>
//       </main>

//       {/* Footer */}
//       <footer className="w-full bg-black text-white mt-auto">
//         <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 max-w-[2000px] mx-auto">
//           <Footer />
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Home;







